import {
  lg,
  cloneDeep,
  util,
  isCorrectVal,
  isDate
} from 'utils';
import NProgress from 'nprogress';
import $http from '$http';
export default {
  methods: {
    //获取单条数据
    getById(OrderId) {
      let params = {
        Sid: this.$store.state.sysSid,
        Session: this.$store.state.sysSession,
        OrderId: OrderId,
      };
      this.loading = true;
      $http.get("api/UserOrder/GetOrderById", params).then(res => {
        let {
          Data,
          Cnt
        } = res.data;
        this.loading = false;
        util.doResult(this, res, () => {
          this.form = Data
          this.BabyInfo = this.form.BabyInfo;
          this.AuditShowData = cloneDeep(this.form.OrderPayInfo[0])
          if (this.form.AgentInfo) {
            this.AgentInfo = this.form.AgentInfo;
            this.SchoolInfo = this.form.SchoolInfo;
            this.ClassInfo = this.form.ClassInfo;
          }
          // 转介绍人信息
          if (this.form.RefereeBabyInfo) {
            this.RefereeBabyInfo = this.form.RefereeBabyInfo
            this.RefereeParentInfo = this.form.RefereeParentInfo
            if (this.form.RefereeBabySchoolInfo) {
              this.RefereeBabySchoolInfo = this.form.RefereeBabySchoolInfo
              this.RefereeBabyAgentInfo = this.form.RefereeBabyAgentInfo
              this.RefereeBabyClassInfo = this.form.RefereeBabyClassInfo
            }
          }

          this.ConsigneeList = this.form.ConsigneeList[0]
          this.groupNum = this.form.GroupList.length + 1
          if (this.form.GroupList.length > 0) {
            this.form.OtherOrder = this.form.GroupList.join(',')
          }

        });
      });
    },
    //配置资源包提交
    ConfigOrderResource() {
      let params = {
        Sid: this.$store.state.sysSid,
        Session: this.$store.state.sysSession,
      };
      this.loading = true;

      $http.post("api/UserOrder/ConfigOrderResource", Object.assign({}, params, this.SubmitData)).then(res => {
        let {
          Data,
          Cnt
        } = res.data;
        this.loading = false;
        util.doResult(this, res, () => {
          this.$notify({
            title: '成功',
            message: '配置成功',
            type: 'success'
          });
          this.$emit('reloadList')
          this.dialogClose()

        });
      });
    },
    // 获取套餐资源包下拉明细
    getDetailsPackage(PackageId) {
      let params = {
        Sid: this.$store.state.sysSid,
        Session: this.$store.state.sysSession,
        PackageId: PackageId,
      };
      this.loading = true;
      $http.get("api/ContinueOrder/GetPackageDetailById", params).then(res => {
        let {
          Data,
          Cnt
        } = res.data;
        this.loading = false;
        util.doResult(this, res, () => {

          this.packages = []
          for (let i = 0; i < Data.length; i++) {
            this.packages.push({
              ProId: Data[i].ProId,
              ProName: Data[i].ProName,
              ProNum: 0
            })
          }
        });
      });
    },
    //审核提交POST /api/UserOrder/UserOrderAuditForFinance
    UserOrderAuditForFinance() {
      let params = {
        Sid: this.$store.state.sysSid,
        Session: this.$store.state.sysSession,
      };
      this.loading = true;

      $http.post("api/UserOrder/UserOrderAuditForFinance", Object.assign({}, params, this.AuditData)).then(res => {
        let {
          Data,
          Cnt
        } = res.data;
        this.loading = false;
        util.doResult(this, res, () => {
          this.$notify({
            title: '成功',
            message: '审核成功',
            type: 'success'
          });
          this.$emit('reloadList')
          this.dialogClose()

        });
      });
    },
  }
}


// WEBPACK FOOTER //
// ./src/pages/Family/OrderList/viewDialog/services.js